import { GameManager } from "../GameManager";
import { GameConstants } from "../GameConstants";
import { AudioManager } from "../AudioManager";
import { Howl } from "howler";
import { GameVars } from "../GameVars";

export class PreloadScene extends Phaser.Scene {

    public static currentInstance: PreloadScene;

    private progressBar: Phaser.GameObjects.Graphics;

    constructor() {

        super("PreloadScene");

        PreloadScene.currentInstance = this;
    }

    public preload(): void {

        GameManager.setCurrentScene(this);

        this.composeScene();

        this.loadAssets();
    }

    public create(): void {

        let audioSpriteJSON = this.cache.json.get("audiosprite");
        audioSpriteJSON = JSON.parse(JSON.stringify(audioSpriteJSON).replace("urls", "src"));
        audioSpriteJSON = JSON.parse(JSON.stringify(audioSpriteJSON).replace("../", ""));
        audioSpriteJSON = JSON.parse(JSON.stringify(audioSpriteJSON).replace("../", ""));

        AudioManager.howl = new Howl(audioSpriteJSON);

        AudioManager.howl.on("load", () => {
            GameManager.onGameAssetsLoaded();
        });
    }

    private composeScene(): void {

        this.add.text(-100, -200, "abcdefg", {fontFamily: "Oswald-ExtraLight", fontSize: "26px", color: "#FFFF00"});
        this.add.text(-100, -150, "abcdefg", {fontFamily: "Oswald-Medium", fontSize: "26px", color: "#FFFF00"});
        this.add.text(0, -100, "abcdefghijk", {fontFamily: "Futura-Medium", fontSize: "30px", color: "#FFFFFF"});
        this.add.text(0, -100, "abcdefghijk", {fontFamily: "Oswald-DemiBold", fontSize: "30px", color: "#FFFFFF"});

        const backgroud = this.add.image(GameConstants.GAME_WIDTH / 2, GameConstants.GAME_HEIGHT / 2, "background");
        backgroud.scaleY = GameVars.scaleY;

        const scaledItemsContainer = this.add.container(GameConstants.GAME_WIDTH / 2, GameConstants.GAME_HEIGHT * .515);
        scaledItemsContainer.scaleY = GameVars.scaleY;

        const barWidth = 550;
        const barWHeight = 10;
        const borderWidth = 3;

        const preloadBarCapsuleBorder = new Phaser.GameObjects.Graphics(this);
        preloadBarCapsuleBorder.fillStyle(0xFFFFFF);
        preloadBarCapsuleBorder.fillRect(0, 0, barWidth + borderWidth * 2, barWHeight + borderWidth * 2);
        preloadBarCapsuleBorder.x = - barWidth / 2 - borderWidth;
        preloadBarCapsuleBorder.y = -borderWidth;
        scaledItemsContainer.add(preloadBarCapsuleBorder);

        const preloadBarCapsule = new Phaser.GameObjects.Graphics(this);
        preloadBarCapsule.fillStyle(0xc6d6dd);
        preloadBarCapsule.fillRect(0, 0, barWidth, barWHeight);
        preloadBarCapsule.x = - barWidth / 2;
        scaledItemsContainer.add(preloadBarCapsule);

        this.progressBar = new Phaser.GameObjects.Graphics(this);
        this.progressBar.fillStyle(0x2e488d);
        this.progressBar.fillRect(0, 0, barWidth, barWHeight);
        this.progressBar.x = - barWidth / 2;
        this.progressBar.scaleX = 0;
        scaledItemsContainer.add(this.progressBar);
    }

    private loadAssets(): void {

        if (GameConstants.DEBUG_MODE) {
            this.load.atlas("texture_atlas_0", "assets/texture_atlas_0.png", "assets/texture_atlas_0.json");
        }

        this.load.atlas("texture_atlas_1", "assets/texture_atlas_1.png", "assets/texture_atlas_1.json");
        this.load.atlas("texture_atlas_2", "assets/texture_atlas_2.png", "assets/texture_atlas_2.json");
        this.load.atlas("texture_atlas_3", "assets/texture_atlas_3.png", "assets/texture_atlas_3.json");

        // LOS ARCHIVOS DE SPINE  
        (this.load as any).spine("mermaid", "assets/spine/mermaid_spine.json", "assets/spine/mermaid_spine.atlas");
        (this.load as any).spine("corals", "assets/spine/corales.json", "assets/spine/corales.atlas");

        // EL TEXTO DEL JUEGO
        this.load.json("game-text", "assets/config/text.json");

        // EL AUDIO SPRITE
        this.load.json("audiosprite", "assets/audio/audiosprite.json");

        this.load.on("progress", this.updateLoadedPercentage, this);
    }

    private updateLoadedPercentage(percentageLoaded: number): void {

        if (this.progressBar.scaleX < percentageLoaded) {
            this.progressBar.scaleX = percentageLoaded;
        }
    }
}
